// Mirrors the server's defaults (DETECT_WORDS_PER_TOKEN / DETECT_MIN_TOKENS in
// humanai-core config.rs) so the price shown on the button IS the charge.
// Change both together.
export const DETECT_WORDS_PER_TOKEN = 2;
export const DETECT_MIN_TOKENS = 50;

/** Credit words charged to score `words` of text. */
export function detectCost(words: number): number {
  return Math.max(DETECT_MIN_TOKENS, Math.ceil(words / DETECT_WORDS_PER_TOKEN));
}
